import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppHeader from '../AppHeader/AppHeader';
import Footer from '../Footer/Footer';
import ContactDialog from '../ContactDialog/ContactDialog';
import styles from './BaseLayout.module.css';

interface BaseLayoutProps {
  headerCustomBg?: boolean;
  children: React.ReactNode;
  isHomePage?: boolean;
}

const BaseLayout: React.FC<BaseLayoutProps> = ({ children, headerCustomBg = false, isHomePage }) => {
  const location = useLocation();
  const [, setIsCalculatorOpen] = useState(false);

  useEffect(() => {
    // Only scroll to top if there's no hash in the URL
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  const handleCalculatorOpen = () => {
    setIsCalculatorOpen(true);
  };

  if (typeof window !== 'undefined') {
    (window as any).openCalculator = handleCalculatorOpen;
  }

  return (
    <div className={styles.baseLayout} data-is-home={isHomePage}>
      <AppHeader hasBackgroundContainer={headerCustomBg} />
      <main>
        {children}
      </main>
      <Footer />
      <ContactDialog />
    </div>
  );
};

export default BaseLayout;